import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, MapPin } from "lucide-react";
import thankyou from "@/translations/thankyou.json";

export default function ThankYou() {
  useEffect(() => {
    document.documentElement.lang = "it";
    document.title = `${thankyou.title} — Anvoriq`;
  }, []);

  return (
    <div
      className="min-h-screen flex flex-col"
      style={{ backgroundColor: "var(--anv-ink)", color: "#fff" }}
      data-testid="thank-you-page"
    >
      <header
        className="w-full border-b border-white/10"
        style={{ backgroundColor: "var(--anv-ink)" }}
      >
        <div className="anv-container flex items-center justify-between py-5">
          <Link to="/" className="flex items-baseline gap-3 no-underline" data-testid="thank-you-brand">
            <span className="font-display text-2xl font-semibold tracking-[0.18em] text-white">
              ANVORIQ
            </span>
            <span className="hidden md:inline text-[11px] uppercase tracking-[0.25em] text-white/60">
              Milano · Strategic Advisory
            </span>
          </Link>
        </div>
      </header>

      <main className="flex-1 flex items-center">
        <div className="anv-container py-20 md:py-28">
          <div className="max-w-3xl">
            <div className="anv-eyebrow" style={{ color: "var(--anv-terra)" }}>
              {thankyou.eyebrow}
            </div>
            <h1 className="font-display mt-5 text-4xl sm:text-5xl lg:text-6xl leading-[1.05] font-semibold text-white">
              {thankyou.title}
            </h1>
            <p className="mt-8 text-white/85 text-base md:text-lg leading-relaxed">
              {thankyou.message}
            </p>
            <p className="mt-4 text-white/70 text-base leading-relaxed">
              {thankyou.secondary}
            </p>
            <div className="mt-10 flex items-center gap-3">
              <Link to="/" className="anv-btn-primary" data-testid="thank-you-back-home">
                <ArrowLeft size={16} /> {thankyou.backHome}
              </Link>
            </div>
            <div className="mt-12 flex items-start gap-3 text-sm text-white/60">
              <MapPin size={16} className="mt-0.5" style={{ color: "var(--anv-terra)" }} />
              <span>{thankyou.office}</span>
            </div>
          </div>
        </div>
      </main>

      <footer className="border-t border-white/10">
        <div className="anv-container py-6 text-xs text-white/50">
          © 2026 Anvoriq S.r.l. — Tutti i diritti riservati.
        </div>
      </footer>
    </div>
  );
}
